import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { STORYBLOK_BFF_URL } from "../../util/api";
import { getStoryBySlugUrlParams } from "./schema";
var hasStoryblokStory = function(input) {
    if (!input || !Object.prototype.hasOwnProperty.call(input, "story")) {
        return false;
    }
    return true;
};
export function getStoryBySlug(slug, params) {
    return _getStoryBySlug.apply(this, arguments);
}
function _getStoryBySlug() {
    _getStoryBySlug = _async_to_generator(function(slug, params) {
        var // eslint-disable-next-line unicorn/no-object-as-default-parameter
        options, urlParams, url, response, error, errorMessage;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {
                        strict: true
                    };
                    urlParams = getStoryBySlugUrlParams.parse(params);
                    urlParams.append("slug", slug);
                    url = "".concat(STORYBLOK_BFF_URL, "/story-by-slug?").concat(urlParams.toString());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(url).then(function(res) {
                            return res.json();
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!hasStoryblokStory(response)) {
                        throw new Error("Story Response has no story property.");
                    }
                    return [
                        2,
                        _object_spread_props(_object_spread({}, response.story), {
                            rels: response.rels
                        })
                    ];
                case 3:
                    error = _state.sent();
                    if (!options.strict) {
                        return [
                            2,
                            null
                        ];
                    }
                    errorMessage = error || "Unknown Error";
                    if (_instanceof(error, Error)) {
                        errorMessage = error.message;
                    }
                    throw new Error("'story-by-slug' endpoint error\n        Original Error: \"".concat(errorMessage, '"\n        Slug: "').concat(slug, '",\n        Failing Url: "').concat(url, '"\n    '));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getStoryBySlug.apply(this, arguments);
}
